module.exports = __webpack_public_path__ + "static/media/m_eyeshape_almond_amber.4ac7471b.png";